module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a8CNN"))).then(() => parcelRequire('hEqeo'));